/* AstaLab 2.0 — /forgot-password (obiettivo 3). */
import { escapeHtml } from "../components/escapeHtml.js";
import { renderNoticeIfAny } from "../components/DemoModeBanner.js";

export function renderForgotPasswordPage(container, ctx){
  container.innerHTML =
    '<div class="auth-card">' +
      '<h1>Recupera la password</h1>' +
      '<form id="forgotForm">' +
        '<label class="field">Email<input type="email" id="forgotEmail" required autocomplete="email"></label>' +
        '<button type="submit" class="btn primary">Invia link di recupero</button>' +
      '</form>' +
      '<div id="forgotMsg"></div>' +
      '<p class="hint"><a href="#/login">Torna al login</a></p>' +
    '</div>';

  const form = container.querySelector("#forgotForm");
  const msg = container.querySelector("#forgotMsg");
  const submitBtn = form.querySelector('button[type="submit"]');
  // Round Beta-P3-2: stessa guardia locale di LoginPage.js — vedi il commento esteso lì.
  let submitting = false;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if(submitting) return;
    submitting = true;
    submitBtn.disabled = true;
    try{
      msg.innerHTML = "";
      const email = container.querySelector("#forgotEmail").value;
      const result = await ctx.adapter.requestPasswordReset(email);
      if(!result.ok){
        msg.innerHTML = '<p class="errtext">' + escapeHtml(result.error) + "</p>";
        return;
      }
      msg.innerHTML = renderNoticeIfAny(result) || '<p class="okmsg">Se l\'indirizzo esiste, riceverai un\'email con le istruzioni.</p>';
    } finally {
      submitting = false;
      submitBtn.disabled = false;
    }
  });
}
